import React from 'react';

import { usePlanEntitlements } from '../billing/planEntitlements';
import { getWorkspaceBilling, startBillingTrial } from '../billing/services/billingService';
import type { WorkspaceBilling } from '../billing/types/billing';
import { channelsAreOpen } from './setupBilling';

export const useSetupBilling = () => {
  const { noteWorkspace } = usePlanEntitlements();
  const [workspace, setWorkspace] = React.useState<WorkspaceBilling | null>(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState<string | null>(null);

  React.useEffect(() => {
    let cancelled = false;
    setLoading(true);

    getWorkspaceBilling()
      .then(next => {
        if (cancelled) {
          return;
        }

        setWorkspace(next);
        noteWorkspace(next);
        setError(null);
      })
      .catch(loadError => {
        if (!cancelled) {
          setError(loadError instanceof Error ? loadError.message : null);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [noteWorkspace]);

  const startTrial = React.useCallback(async () => {
    const next = await startBillingTrial();
    setWorkspace(next);
    noteWorkspace(next);
    return next;
  }, [noteWorkspace]);

  return {
    workspace,
    loading,
    error,
    channelsOpen: channelsAreOpen(workspace),
    startTrial,
  };
};
